import React from 'react';
import { MailIcon, InstagramIcon } from 'lucide-react';
export function Footer() {
  return <footer className="border-t border-grape/15 bg-white/70" data-id="element-50" data-mp="3gezfnanhw34b">
      <div className="mx-auto max-w-4xl px-5 py-12 text-center" style={{
      paddingTop: "25px"
    }} data-id="element-51" data-mp="3ghc2o28413o8">
        <p className="font-display text-xl font-black text-plum" data-id="element-52" data-mp="32m1bayt2r0om">
          THE 360° MUSCLE RECOVERY SYSTEM<span className="align-super text-xs" data-id="element-53" data-mp="36n3d9nedlqua">™</span>
        </p>
        <p className="mx-auto mt-3 max-w-xl text-sm leading-relaxed text-plum/65" data-id="element-54" data-mp="3ugbpd4c2b8hr">
          The visual method to recover from any muscle injury from absolute zero: severity
          assessment, progressive loading, fiber remodeling and return-to-action criteria in 30
          days.
        </p>

        <div className="mt-8 flex flex-wrap items-center justify-center gap-x-6 gap-y-3 text-sm text-plum/75" data-id="element-55" data-mp="3qc445h4tcaoa">
          <a href="mailto:soporte.sigmasmart@gmail.com" className="inline-flex items-center gap-2 transition-colors duration-150 ease-out hover:text-grape" data-id="element-56" data-mp="29xvps9u757nq">
            <MailIcon className="h-4 w-4 text-grape" data-id="element-57" data-mp="3l8qupznvcbpc" /> soporte.sigmasmart@gmail.com
          </a>
          <a href="#" className="inline-flex items-center gap-2 transition-colors duration-150 ease-out hover:text-grape" data-id="element-58" data-mp="3gaz73hu9bbqy">
            <InstagramIcon className="h-4 w-4 text-grape" data-id="element-59" data-mp="3v8hrk7zwj2sl" /> @sigmasmart.en
          </a>
          
        </div>

        <p className="mt-4 font-display text-base font-semibold italic text-grape" data-id="element-60" data-mp="3q727ai5jt0b9">
          🏥 “Your recovery starts today.”
        </p>

        <div className="mt-8 flex flex-wrap justify-center gap-x-4 gap-y-2 text-xs text-plum/45" data-id="element-61" data-mp="33xge4qruavo">
          <a href="#" className="transition-colors duration-150 ease-out hover:text-plum" data-id="element-62" data-mp="hstrybs1e611">
            Terms & Conditions
          </a>
          <span data-id="element-63" data-mp="cus29803v8gl">·</span>
          <a href="#" className="transition-colors duration-150 ease-out hover:text-plum" data-id="element-64" data-mp="cuil89x1gbn1">
            Privacy Policy
          </a>
          <span data-id="element-65" data-mp="mrwqdddihe01">·</span>
          <a href="#" className="transition-colors duration-150 ease-out hover:text-plum" data-id="element-66" data-mp="msg56l7v7m9u">
            Support
          </a>
        </div>

        <p className="mt-8 text-xs leading-relaxed text-plum/40" data-id="element-67" data-mp="twnzthrs0v1i">
          © 2026 THE 360° MUSCLE RECOVERY SYSTEM™ — SIGMA SMART™ — All rights reserved.
          Reproduction and redistribution prohibited without express authorization.
        </p>
      </div>
    </footer>;
}